import {
  Box,
  Flex,
  Heading,
  IconButton,
  useDisclosure,
  Stack,
  Link,
  Text,
} from "@chakra-ui/react";
import {Link as SLink} from 'react-scroll'
import React from "react";
import Logo from "./Logo";
import NavLink from "./NavLink";
import NavMenuTongle from "./NavMenuTongle";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";

export default function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  // const [isOpen, setIsOpen] = React.useState(false);

  // const toggle = () => setIsOpen(!isOpen);
  return (
    <Box
      backgroundColor={"csudark"}
      position={"fixed"}
      zIndex="1"
      transition={".3s ease-in"}
      overflow="hidden"
      width={"100%"}
      top={0}
      left={0}
    >
      <Flex
        backgroundColor={"csudark"}
        justifyContent="space-around"
        alignItems="center"
        flexWrap={"wrap"}
      >
         <SLink to="home" smooth={true} offset={-100} duration={500}>
        <Flex cursor={"pointer"} alignItems="center">
       
        <Logo></Logo>
          <Box gap={0}>
            <Heading margin={0} color={"cpdark"}>
              SUHAIL K
            </Heading>
            <Text margin={0} color={"whiteAlpha.600"}>
              Full Stack Web Developer
            </Text>
          </Box>
          </Flex>
          </SLink>
        
        <Stack
          spacing={1}
          align="center"
          justify={["center", "space-between", "flex-end", "flex-end"]}
          display={{ base: "none", md: "flex" }}
          direction={{ base: "none", md: "row" }}
          pt={[4, 4, 0, 0]}
        >
            <NavLink to={"home"} text={" Home "}></NavLink>
          <NavLink to={"aboutme"} text={" About "}></NavLink>
          <NavLink to={"experience"} text={" Experience "}></NavLink>
          <NavLink to={"skills"} text={" Skills "}></NavLink>
          <NavLink to={"projects"} text={" Work "}></NavLink>

          <NavLink to={"contactme"} text={" Contact "}></NavLink>

          <Link
            isExternal
            href="https://drive.google.com/file/d/1z1u2vlXYc15YC4cj9isdR1qUlZD54LlU/view?usp=share_link"
          >
            {" "}
            <Flex role={"group"} padding={2} borderRadius={5}>
              <Text
                color={"cplite"}
                _groupHover={{
                  color: "white",
                  transition: 10,
                  cursor: "pointer",
                }}
              >
                {"< "}
              </Text>
              &nbsp;
              <Text
                color={"white"}
                transition="all .25s ease"
                _groupHover={{
                  color: "cplite",
                  transition: 10,
                  cursor: "pointer",
                  transform: "scale(1.1)",
                }}
              >
                Resume
              </Text>
              &nbsp;
              <Text
                color={"cplite"}
                _groupHover={{
                  color: "white",
                  transition: 10,
                  cursor: "pointer",
                }}
              >
                {" />"}
              </Text>
            </Flex>
          </Link>
        </Stack>
        <IconButton
          size={"md"}
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label={"Open Menu"}
          display={{ md: "none" }}
          onClick={isOpen ? onClose : onOpen}
        ></IconButton>
        {/* <NavMenuTongle toggle={toggle} isOpen={isOpen}></NavMenuTongle> */}
      </Flex>

      {isOpen ? (
        <Box backgroundColor={"csudark"} display={{ md: "none" }}>
          <Stack justifyContent={"center"} alignItems={"center"} spacing={2}>
            <NavLink to={"aboutme"} text={" About "}></NavLink>
            <NavLink to={"experience"} text={" Experience "}></NavLink>
            <NavLink to={"skills"} text={" Skills "}></NavLink>
            <NavLink to={"projects"} text={" Work "}></NavLink>

            <NavLink to={"contactme"} text={" Contact "}></NavLink>
            <Link
              isExternal
              href="https://drive.google.com/file/d/1z1u2vlXYc15YC4cj9isdR1qUlZD54LlU/view?usp=share_link"
            >
              {" "}
              <Flex role={"group"} padding={2} borderRadius={5}>
                <Text
                  color={"cplite"}
                  _groupHover={{
                    color: "white",
                    transition: 10,
                    cursor: "pointer",
                  }}
                >
                  {"< "}
                </Text>
                &nbsp;
                <Text
                  color={"white"}
                  transition="all .25s ease"
                  _groupHover={{
                    color: "cplite",
                    transition: 10,
                    cursor: "pointer",
                    transform: "scale(1.1)",
                  }}
                >
                  Resume
                </Text>
                &nbsp;
                <Text
                  color={"cplite"}
                  _groupHover={{
                    color: "white",
                    transition: 10,
                    cursor: "pointer",
                  }}
                >
                  {" />"}
                </Text>
              </Flex>
            </Link>
          </Stack>
        </Box>
      ) : null}
    </Box>
  );
}
